import { Link } from "react-router-dom";
import { BRAND_NAME, CONTACTS } from "@/lib/constants";
import { useAuth } from "@/contexts/AuthContext";
import { useCatalog } from "@/hooks/use-catalog";
import { catalogHref } from "@/lib/catalog-paths";

// py-1 with a matching -my-1 grows each link's tap area into the row gap without moving it.
const linkClass = "-my-1 inline-block py-1 transition-colors hover:text-primary";

export const Footer = () => {
  const { isAuthenticated } = useAuth();
  const { data } = useCatalog({ enabled: isAuthenticated });
  const footerCategories = data?.categories ?? [];

  return (
    <footer className="surface-dark border-t border-border">
      <div className="container py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          <div className="col-span-2 md:col-span-1">
            <p className="text-xl font-bold tracking-tight text-white">{BRAND_NAME}</p>
            <p className="text-sm text-white/80">Надёжный инструмент для профессионалов</p>
            <p className="mt-2 text-sm text-white/65">{CONTACTS.address}</p>
          </div>

          <div>
            <h4 className="card-title mb-4 text-white">Каталог</h4>
            <ul className="space-y-2 text-sm text-white/70">
              {footerCategories.length > 0 ? (
                footerCategories.map((category) => (
                  <li key={category.id}>
                    <Link to={catalogHref([category.id])} className={linkClass}>
                      {category.name}
                    </Link>
                  </li>
                ))
              ) : (
                <li>
                  <Link to="/catalog" className={linkClass}>
                    Смотреть каталог
                  </Link>
                </li>
              )}
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h4 className="card-title mb-4 text-white">Контакты</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li>
                <a href={CONTACTS.phoneHref} className={linkClass}>
                  {CONTACTS.phone}
                </a>
              </li>
              <li>
                <a href={CONTACTS.emailHref} className={linkClass}>
                  {CONTACTS.email}
                </a>
              </li>
              <li>{CONTACTS.workingHours}</li>
              <li>{CONTACTS.weekend}</li>
            </ul>
          </div>
        </div>

        <div className="mt-6 border-t border-white/15 pt-6">
          <div className="flex flex-col items-center justify-between gap-4 text-sm text-white/65 md:flex-row">
            <div className="text-center md:text-left">{`© 2026 ООО «${BRAND_NAME}». Все права защищены.`}</div>
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 md:gap-6 text-xs md:text-sm">
              <Link to="/privacy" className={linkClass}>
                Политика конфиденциальности
              </Link>
              <Link to="/terms" className={linkClass}>
                Условия использования
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
